import { ProductType } from 'sections/Company/VisionStrategy/types';

export const productsData: ProductType[] = [
  {
    id: 1,
    iconName: 'icon-logistics-explorer',
    description: (cn: Function) => (
      `
        <p class='${cn('products__paragraph')}'>Integrate your website with the <a class='${cn('products__link')}' href='/digital-tools/logistics-explorer' target='_blank'>Logistics Explorer</a> product. This product is a rate management system that allows customers visiting the website to quickly obtain rates.</p>
        <p class='${cn('products__paragraph')}'>* There is zero cost to do this when joining on a Standard membership no charge package.</p>
      `
    ),
  },   
  {
    id: 2,
    iconName: 'icon-enquiries',
    description: (cn: Function) => (
      `
        <p class='${cn('products__paragraph')}'>Take a further step and on a Premium package use that same Logistics Explorer software to utilize a widget which permits you to either advertise your rates and services to up to <span class='${cn('products__text--bold')}'>20,000</span> cargo enquiries a day on <a class='${cn('products__link')}' href='https://www.searates.com'>SeaRates.com</a> and/or advertise your rates among a select group of premium members whom you nominate as partners.</p>
      `
    ),
  },   
  {
    id: 3,
    iconName: 'chart-02',
    description: (cn: Function) => (
      `
        <p class='${cn('products__paragraph')}'>These first two stages are about deciding the size of the funnel, the size of the shop window, to attract business. The choice of scope is always with the member. In all cases, a premium membership will come with an account manager who actively pushes cargo leads in your direction.</p>
      `
    ),
  },   
  // {
  //   id: 4,
  //   iconName: 'icon-cargoes',
  //   description: (cn: Function) => (
  //     `
  //       <p class='${cn('products__paragraph')}'><a class='${cn('products__link')}' href='/digital-tools/cargoes-flow'>Cargoes Flow</a>. It is an enterprise, multi-vendor tracking tool for sea, air and land. It benefits large companies working with multiple logistics vendors, providing a single window view.</p>
  //     `
  //   ),
  // },   
];